import 'vue-swatches/dist/vue-swatches.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import i18n from './i18n';
import Toast from 'vue-toastification';
import App from './App.vue';
import router from './router';
import store from './store';
import PortalVue from 'portal-vue';
// Socket.IO temporarily disabled
// import VueSocketIO from 'vue-socket.io';
// import { io } from 'socket.io-client';
import './assets/tailwind.css';
import './styles/main.scss';
import debounceInput from './directives/debounce-input';
import toastOptions from '@/config/toast';
// @ts-ignore
import vClickOutside from 'v-click-outside';
import { LOCAL_STORAGE_KEY, useLocalStorage, } from '@/composables/use-local-storage';
import SentryAzure from './plugins/sentry-azure';
import { setSentryUser, getUserContextForSentry } from '@/util/sentry-user';
import * as Sentry from '@sentry/vue';
if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.NODE_ENV,
        sendDefaultPii: true,
        beforeSend(event, hint) {
            if (!event.user?.id || !event.user?.email) {
                try {
                    const storedData = localStorage.getItem('objekto');
                    if (storedData) {
                        const parsed = JSON.parse(storedData);
                        const userData = parsed?.user;
                        if (userData?.id && userData?.email) {
                            event.user = {
                                id: String(userData.id),
                                email: userData.email,
                                username: userData.email,
                            };
                            event.contexts = {
                                ...event.contexts,
                                user_details: {
                                    firstName: userData.firstName,
                                    lastName: userData.lastName,
                                    role: userData.role,
                                    type: userData.type,
                                    systemRole: userData.systemRole,
                                },
                            };
                        }
                    }
                }
                catch (error) {
                    console.warn('Could not attach user data to Sentry event:', error);
                }
            }
            if (event.tags?.module === 'azure') {
                event.extra = {
                    ...event.extra,
                    timestamp: new Date().toISOString(),
                    userAgent: navigator.userAgent,
                    location: window.location.href,
                    localStorage: {
                        hasToken: !!localStorage.getItem('token'),
                        hasUser: !!localStorage.getItem('user'),
                    },
                };
            }
            return event;
        },
        tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    });
    try {
        const storedData = localStorage.getItem('objekto');
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const userData = parsed?.user;
            if (userData?.id && userData?.email) {
                setSentryUser(getUserContextForSentry(userData));
            }
        }
    }
    catch (error) {
        console.warn('Could not set initial Sentry user:', error);
    }
}
Vue.use(VueCompositionAPI);
Vue.use(Toast, toastOptions);
Vue.use(vClickOutside);
Vue.use(PortalVue);
Vue.use(SentryAzure);
const { storedValue } = useLocalStorage(LOCAL_STORAGE_KEY.OBJEKTO);
/* Socket.IO temporarily disabled
Vue.use(
  new VueSocketIO({
    debug: process.env.NODE_ENV === 'development',
    connection: io(process.env.VUE_APP_API_URL as string, {
      withCredentials: true,
      autoConnect: false,
    }),
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_',
    },
  }),
);
*/
Vue.config.productionTip = false;
// @ts-ignore
Vue.directive('debounceInput', debounceInput);
export const rootOptions = {
    router,
    store,
    i18n,
};
export default new Vue({
    ...rootOptions,
    render: (h) => h(App),
}).$mount('#app');
